export const SET_INSTANCES = "SET_INSTANCES";
export const SET_INSTANCE = "SET_INSTANCE";
export const ADD_INSTANCE = "ADD_INSTANCE";
export const DELETE_INSTANCE = "DELETE_INSTANCE";
export const SET_EDITING_INSTANCE = "SET_EDITING_INSTANCE";
